import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";
import { NotificationSubscriptionOption, NotificationSubscriptionParam } from "@/services/bedrock/dtos";

const USERS_SERVICE = `${Constants.API_URL}/bedrock/users`;

export class NotificationSubscriptionServices {
  @scCatchServiceException()
  static async getNotificationSubscriptions(userId: string | number): Promise<NotificationSubscriptionOption[]> {
    const { data } = await axios.get<NotificationSubscriptionOption[]>(
      `${USERS_SERVICE}/${userId}/notification_subscriptions`
    );
    return data;
  }

  @scCatchServiceException()
  static async updateNotificationSubscriptions(
    userId: string | number,
    subscriptions: NotificationSubscriptionParam[]
  ): Promise<NotificationSubscriptionOption[]> {
    const { data } = await axios.post<NotificationSubscriptionOption[]>(
      `${USERS_SERVICE}/${userId}/notification_subscriptions`,
      { subscriptions }
    );
    return data;
  }
}
